import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity9 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_9;
}

export default GravelRoadTileEntity9;
